module.exports = __webpack_public_path__ + "static/media/visa.ae5707db.svg";